export default "__VITE_ASSET__BB4zEYb4__"